module.exports = __webpack_public_path__ + "static/media/apple.9343d718.png";